var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ship-detail-sections-wrapper" } }, [
    _vm.shipData
      ? _c("section", { attrs: { id: "section-schiff" } }, [
          _c(
            "div",
            { staticClass: "no-padding ship-image-wrapper" },
            [
              _c(
                "a",
                { staticClass: "img-link" },
                [
                  _vm.getLargestAvailableImage(_vm.shipData.bilder[0].filenames)
                    ? _c("responsive-image", {
                        attrs: {
                          alt: _vm.shipData.bezeichnung,
                          title: _vm.shipData.bezeichnung,
                          src: _vm.getLargestAvailableImage(
                            _vm.shipData.bilder[0].filenames
                          ),
                          "src-xs": _vm.shipData.bilder[0].filenames.img800_3x1,
                          "src-sm": _vm.shipData.bilder[0].filenames.img800_3x1,
                          "src-md":
                            _vm.shipData.bilder[0].filenames.img1200_3x1,
                          "src-lg":
                            _vm.shipData.bilder[0].filenames.img1200_3x1,
                          "fixed-aspect-ratio": "3/1",
                          "lazy-load": false,
                          "img-class": "img-responsive",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasShipPano
                ? _c(
                    "a",
                    {
                      staticClass:
                        "fancybox-pano btn btn-round-badge ship-pano-badge",
                      attrs: {
                        "data-fancybox": "krpano-ship",
                        "data-src": "#krpano-ship",
                        href: "#krpano-ship",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showShipPano = true
                        },
                      },
                    },
                    [_vm._v("360°"), _c("br"), _vm._v("Panorama\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasShipPano
                ? _c("pano-viewer", {
                    attrs: {
                      "lazy-load": true,
                      id: "krpano-ship",
                      "show-pano": _vm.showShipPano,
                      logo: _vm.logo,
                      scenes: _vm.shipPano,
                      debug: false,
                      title: _vm.shipData.bezeichnung,
                      xml:
                        "/packages/travel/data/panorama/" +
                        _vm.shipData.schiffscode +
                        "/pano_new.xml",
                      pano_image_dir: "pano_images/",
                      hotspot_dir:
                        "/packages/travel/themes/mittelthurgau/images/pano/",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "container wider-padding ship-detail-sections ship-detail-overview",
            },
            [
              _c("h2", { staticClass: "mt-0" }, [
                _vm._v(_vm._s(_vm.shipData.name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-6" }, [
                  _vm.shipData.beschrieb
                    ? _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.shipData.beschrieb) },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _vm.shipData.technischedaten
                    ? _c("div", { staticClass: "well ship-technical-data" }, [
                        _c("h4", [_vm._v("Technische Daten")]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _c("thead"),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.shipData.technischedaten, function (td) {
                              return _c("tr", [
                                _c("th", [_vm._v(_vm._s(td.spalte1))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(td.spalte2))]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.shipData.kabine &&
              _vm.shipData.kabine.titel &&
              _vm.shipData.kabine.beschreibung &&
              _vm.shipData.kabine.beschreibung[0].text
                ? _c("h2", [_vm._v(_vm._s(_vm.shipData.kabine.titel))])
                : _vm._e(),
              _vm._v(" "),
              _vm.shipData.kabine
                ? _c("div", { staticClass: "row" }, [
                    _vm.shipData.kabine.beschreibung &&
                    _vm.shipData.kabine.beschreibung[0].text
                      ? _c("div", { staticClass: "col-sm-6" }, [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.shipData.kabine.beschreibung[0].text
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _vm.shipData.deckplaene
                        ? _c(
                            "div",
                            { staticClass: "ship-deck-map" },
                            _vm._l(
                              _vm.shipData.deckplaene.bilder,
                              function (b) {
                                return _c(
                                  "div",
                                  { staticClass: "image-gallery" },
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.shipData.deckplaene.bezeichung
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.getLargestAvailableImage(
                                      b.filenames,
                                      ""
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "img-link",
                                            attrs: {
                                              "data-fancybox": "deckplan",
                                              "data-caption":
                                                _vm.shipData.deckplaene
                                                  .bezeichung,
                                              href: _vm.getLargestAvailableImage(
                                                b.filenames,
                                                ""
                                              ),
                                            },
                                          },
                                          [
                                            _c("responsive-image", {
                                              attrs: {
                                                alt: _vm.shipData.deckplaene
                                                  .bezeichung,
                                                title:
                                                  _vm.shipData.deckplaene
                                                    .bezeichung,
                                                src: _vm.getLargestAvailableImage(
                                                  b.filenames,
                                                  ""
                                                ),
                                                "src-xs": b.filenames.img800,
                                                "src-sm": b.filenames.img800,
                                                "src-md": b.filenames.img800,
                                                "src-lg": b.filenames.img800,
                                                "img-class":
                                                  "travel-detail-picture img-responsive",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.shipData && _vm.shipData.kabine
            ? _c("div", { attrs: { id: "sectioin-kabinen" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "container ship-cabins bg-lightgray wider-padding ship-detail-sections",
                  },
                  _vm._l(_vm.shipData.kabine.kabinenDeck, function (k) {
                    return _c("div", { staticClass: "ship-cabin-item" }, [
                      k.bilder
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-xs-12" }, [
                              _c("h3", { staticClass: "ship-cabin-title" }, [
                                _vm._v(_vm._s(k.kabinen_deck)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "ship-cabin-legend" },
                                _vm._l(k.farben, function (hex) {
                                  return _c("div", {
                                    staticClass: "ship-cabin-legend-item",
                                    style: "background-color:#" + hex + ";",
                                  })
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            k.bilder[1]
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-6 image-gallery",
                                  },
                                  [
                                    _vm.getLargestAvailableImage(
                                      k.bilder[1].filenames,
                                      "3x2"
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "img-link ",
                                            attrs: {
                                              "data-fancybox": "kabinen",
                                              href: _vm.getLargestAvailableImage(
                                                k.bilder[1].filenames,
                                                "3x2"
                                              ),
                                            },
                                          },
                                          [
                                            _c("responsive-image", {
                                              attrs: {
                                                alt: "",
                                                title: "",
                                                src: _vm.getLargestAvailableImage(
                                                  k.bilder[1].filenames,
                                                  "3x2"
                                                ),
                                                "src-xs":
                                                  k.bilder[1].filenames
                                                    .img800_3x2,
                                                "src-sm":
                                                  k.bilder[1].filenames
                                                    .img400_3x2,
                                                "src-md":
                                                  k.bilder[1].filenames
                                                    .img400_3x2,
                                                "src-lg":
                                                  k.bilder[1].filenames
                                                    .img800_3x2,
                                                "img-class":
                                                  "ship-detail-picture img-responsive ship-cabin-image",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            k.bilder[0]
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-6 image-gallery",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ship-cabin-plan-wrapper",
                                      },
                                      [
                                        _vm.getLargestAvailableImage(
                                          k.bilder[0].filenames
                                        )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "img-link",
                                                attrs: {
                                                  "data-fancybox":
                                                    "kabinenplan",
                                                  "data-caption":
                                                    k.kabinen_deck,
                                                  href: _vm.getLargestAvailableImage(
                                                    k.bilder[0].filenames
                                                  ),
                                                },
                                              },
                                              [
                                                _c("responsive-image", {
                                                  staticClass: "img-responsive",
                                                  attrs: {
                                                    alt: k.kabinen_deck,
                                                    title: k.kabinen_deck,
                                                    src: _vm.getLargestAvailableImage(
                                                      k.bilder[0].filenames
                                                    ),
                                                    "src-xs":
                                                      k.bilder[0].filenames
                                                        .img800,
                                                    "src-sm":
                                                      k.bilder[0].filenames
                                                        .img400,
                                                    "src-md":
                                                      k.bilder[0].filenames
                                                        .img400,
                                                    "src-lg":
                                                      k.bilder[0].filenames
                                                        .img800,
                                                    "img-class":
                                                      "travel-detail-picture img-responsive ship-cabin-plan",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "container ship-impressions bg-lightgray ship-detail-sections wider-padding",
                  },
                  [
                    _c("travel-gallery", {
                      staticClass: "mt-0",
                      attrs: { bilder: _vm.shipData.bilder, excludes: [0] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.travelData && _vm.travelData.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "container ship-travels-list wider-padding ship-detail-sections",
                      },
                      [
                        _c("h2", { staticClass: "mt-0" }, [
                          _vm._v("Aktuelle Reisen"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "list-group list-travel" },
                          [
                            _c(
                              "transition-group",
                              {
                                staticClass: "animate__animated",
                                attrs: {
                                  tag: "div",
                                  appear: "",
                                  "appear-class": "animate__fadeIn",
                                  "enter-class": "animate__fadeInUp",
                                  "enter-to-class": "animate__fadeInUp",
                                  "leave-to-class": "animate__fadeOut",
                                },
                              },
                              _vm._l(_vm.travelData, function (item) {
                                return _c("travel-list-item", {
                                  key: item.code,
                                  attrs: { "trip-data": item },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }